export const AUTH_SSO_SIGN_IN = "/api/v1/autosso/signin";
export const DEFAULT_AUTH_MEMBER_APP_URL = "https://stg-online.thk.com/tom/us/en/login";
export const SLO_COOKIE_NAME = "signin_on_locale";
export const SLO_CONFIG_URL = "/api/v1/slo/config";
